
import { defineComponent, PropType } from 'vue';
import ButtonModel from '@/models/ButtonModel';

export default defineComponent({
	name: 'answer-button',

	props: {
		button: {
			type: Object as PropType<ButtonModel>,
			required: true
		},

		leftIcon: {
			type: String,
			default: ''
		},

		isWidget: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},

	emits: ['click-button-with-payload'],

	methods: {
		clickOnButton() {
			const text = this.button.command ?? this.button.text;
			const type = this.button.command ? 'command' : 'text-my';

			const payload = {
				text,
				textBody: this.button.text,
				params: this.button.params,
				type,
				link: this.button.link,

				// Тут у нас может быть action либо какой нибудь другой тип в будущем
				buttonType: this.button.type
			};

			this.$emit('click-button-with-payload', payload);
		}
	}
});
